<template>
  <div class="company-wrapper">
    <CompanyInfoDetails class="section-margin" />
    <MoreTitle title="主营构成分析" class="rk-title--company edge-padding" />
    <div class="section-item section-margin">
      <MoreTitle title="按业务" />
      <MainBusinessDetails class="edge-padding" segmentType="B" />
    </div>
    <div class="section-item">
      <MoreTitle title="按地区" />
      <MainBusinessDetails class="edge-padding" segmentType="G" />
    </div>
  </div>
</template>

<script>
import CompanyInfoDetails from '@/components/f10/company/CompanyInfoDetails.vue'
import MainBusinessDetails from '@/components/f10/mainBusiness/MainBusinessDetails.vue'
export default {
  components: { CompanyInfoDetails, MainBusinessDetails }
}
</script>

<style lang="scss" scoped>
.company-wrapper {
  .rk-title--company {
    --rk-title-font-size: 16px;
    --rk-title-font-weight: 400;
  }
  .section-item {
    background: var(--bg-color-2);
  }
}
</style>
